import { useEffect, type ReactNode } from "react";
import ReactDOM from "react-dom";
import { X } from "lucide-react";
import "./Modal.css";

interface ModalProps {
  children: ReactNode;
  onClose: () => void;
  className?: string;
  fullScreen?: boolean;
}

export function Modal({
  children,
  onClose,
  className,
  fullScreen,
}: ModalProps) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (target.closest("[data-portal]")) return;
      const modal = document.querySelector(".modal");
      if (modal && !modal.contains(target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div className="modal-overlay">
      <div
        className={`modal${fullScreen ? " modal-fullscreen" : ""}${className ? ` ${className}` : ""}`}
      >
        <button
          onClick={onClose}
          className="modal-close-btn"
          aria-label="Fermer"
        >
          <X size={24} />
        </button>
        <div className="modalContainer">{children}</div>
      </div>
    </div>,
    document.getElementById("modal-root")!,
  );
}
